<div id="container" class="p-grid p-md-offset-2">
    <article>
        <div class="p-md-10">
            <div class="p-md-10">
                <h1>Space Battle - Game developed in Javascript</h1>
                <p>It is a difficult time as we are all in lockdown, but it is a good time to work on some side projects.
                In order to practice my skills in <i>Javascript</i>, I decided to develop the <mark>Space Battle game</mark>.</p>
                
                <p>The challenging part during the development was the timeout behind the motion of aliens and bombs. If it is not cleared,
                    apparently it will continue to run in the background. For every alien and bomb, there is a timeout which makes the motion possible
                    and it was important to clear all of them. If that did not happen, what you would experience would be the following scenario:</p>
                    <p>
                        You kill an alien and the alien vanishes from the screen, but after some seconds depending from how far the alien was from the red line,
                        the game would stop. Simply because, that alien still continued to move in background and the clearTimeout had cleared 
                        only one of the timeouts created.
                    </p>
                <p>At the end of the game, the scoreboard shows the top 5 players that have scored higher. It is stored in the localStorage.</p>
                <p><b>Github link: </b><a href="https://github.com/lejdiprifti/spacebattle" target="_blank">https://github.com/lejdiprifti/spacebattle</a></p>
                </div>
                <div class="p-md-10">
                    <iframe width="100%" height="415" 
                    src="https://www.youtube.com/embed/-QmodzBHIQs" 
                    frameborder="0" 
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                    allowfullscreen></iframe>
                </div>
        </div>
    </article>
    <div class="fb-share-button" data-href="https://lejdiprifti.web.app" data-layout="button_count" data-size="small"><a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore">Share</a></div>
</div>